var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgImport = function SvgImport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9995 15.5839V3.00089C10.9995 2.4479 11.4475 2.00089 11.9995 2.00089C12.5525 2.00089 12.9995 2.4479 12.9995 3.00089V15.5839L17.1215 11.4629C17.5125 11.0719 18.1455 11.0719 18.5355 11.4629C18.9265 11.8539 18.9265 12.4859 18.5355 12.8769L12.8785 18.5339C12.8495 18.5629 12.8185 18.5899 12.7875 18.6139C12.6035 18.8489 12.3195 18.9979 11.9995 18.9979C11.6805 18.9979 11.3955 18.8489 11.2125 18.6139C11.1815 18.5899 11.1495 18.5629 11.1215 18.5339L5.4645 12.8769C5.0735 12.4859 5.0735 11.8539 5.4645 11.4629C5.8545 11.0719 6.4875 11.0719 6.8785 11.4629L10.9995 15.5839Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 20H2.9995C2.4495 20 1.9995 20.45 1.9995 21C1.9995 21.55 2.4495 22 2.9995 22H20.9995C21.5505 22 21.9995 21.55 21.9995 21C21.9995 20.45 21.5505 20 20.9995 20Z"
  })));
};
export default SvgImport;